<template>
  <div class="cart-container">
      <van-nav-bar title="CARRELLO" @click-left="$store.state.showCart = false" left-arrow />
      <div class="cart-list-wrapper">
          <div class="cart-dish-item" v-for="(dish, index) in $store.state.cart" :key="index">
                <div class="cart-thumb"><img :src="dish.img"></div>
                <div class="cart-dish-info">
                    <div>{{dish.name}}</div>
                    <ul v-if="dish.is_menu == 1">
                      <li v-for="(d, index) in dish.menu_fixed" :key="'m'+index">{{d.id}}. {{d.name}}</li>
                    </ul>
                    <div class="cart-info-footer">
                      <div class="cart-price">€{{(dish.price * dish.quantity).toFixed(2)}}</div>
                      <div>
                        <div style="line-height:22px; height:22px;" v-if="dish.is_menu == 1">
                        <span>x {{dish.quantity}} </span>
                        <span> <van-icon @click="delItem(dish.id)" name="clear" size="22" color="red" /></span>

                        </div>
                        <van-stepper v-if="dish.is_menu == 2" @plus="plus(dish)" @minus="minus(dish.id)" button-size="22" theme="round" v-model="dish.quantity" min="0" />
                      </div>
                    </div>
                </div>
          </div>
      </div>
      <div class="checkout-button">
        <div>
          <van-cell title="SubTotale" :value="'€'+cartSubtotal" size="large" />
        </div> 
        <van-button :to="'/'+$route.params.mid+'/checkout'" type="primary" round>CHECKOUT</van-button>
      </div>
  </div>
</template>
<script>
export default {
  name: 'Cart',
  data(){
      return {
            cart:[]
      }
  },
  computed:{
    cartSubtotal(){
      return (parseFloat(this.$store.getters.subTotalAmount) + parseFloat(this.$store.getters.totalPriceMenuFixed)).toFixed(2)
    }
  },
  methods:{
   getCartDishes(){
            const username = window.atob(localStorage.getItem(window.btoa('user')))
            const user_mid = {user:username, mid:this.$route.params.mid}
            this.axios.get('/api/cart/cartList', {params:user_mid}).then((res)=>{
                this.$store.state.cart = res.data.data
            })
    },
    plus(dish){
          dish['mid'] = this.$route.params.mid
          dish['user'] = window.atob(localStorage.getItem(window.btoa('user')))
        
          this.axios.post('/api/cart/add', dish).then((res)=>{
            if(res.data.code == 200){
              this.$store.state.cart = res.data.data
              return
            }      
      })
      },
      minus(id){
          var item = {}
          item['mid'] = this.$route.params.mid
          item['user'] = window.atob(localStorage.getItem(window.btoa('user')))
          item['id'] = id
          this.axios.post('/api/cart/minus', item).then((res)=>{
           this.$store.state.cart = res.data.data
          })
      },
      delItem(id){
          var item = {}
          item['mid'] = this.$route.params.mid
          item['user'] =  window.atob(localStorage.getItem(window.btoa('user')))
          item['id'] = id
          
          this.axios.post('/api/cart/del', item).then((res)=>{
            this.$store.state.cart = res.data.data
          })
        }
  }
}
</script>
<style>
  .cart-container{
    height: 100%;
    overflow: hidden;
  }
  .cart-list-wrapper{
    padding: 5px;
    height: calc(100% - 170px);
    overflow-y: scroll;
  }
  .cart-list-wrapper::-webkit-scrollbar {
    display: none;
  }
  .checkout-button{
    width: 100%;
    padding: 10px 20px;
  }
  .checkout-button .van-button{
    width: 100%;
    font-size: 22px;
    height: 50px;
  }
  .cart-dish-item{
      margin-bottom: 5px;
      padding-bottom: 5px;
      display: flex;
      border-bottom:1px solid #e4e4e4;
  }
  .cart-thumb{
      width: 105px;
      height: 80px;
      flex: 2;
  }
  .cart-thumb img{
      width: 100%;
      height: 100%;
      object-fit: cover;
  }
  .cart-dish-info{
        min-height: 80px;
        padding: 5px;
        display: flex;
        flex-direction: column;
        flex: 5;
        justify-content: space-between;
  }
  .cart-dish-info ul{
    padding-left: 10px;
    margin-bottom: 10px;
  }
  .cart-dish-info ul li{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: calc(100% - 10px);
    color: #5f5d5d;
  }
  .cart-price{
    color:red;
    line-height: 22px;
  }
  .cart-info-footer{
    display: flex;
    justify-content: space-between;
  }

  .cart-container .van-cell--large .van-cell__title{
    font-size: 18px;
  }
  .cart-container .van-cell--large .van-cell__value{
    font-size: 18px;
  }
</style>